import { Expand } from "lucide-react";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1769144256227-5185141c3aca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHNoaXBwaW5nJTIwcG9ydCUyMGNvbnRhaW5lciUyMGFlcmlhbHxlbnwwfHx8fDE3NzgwMzkxMDJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Aerial view of stacked shipping containers",
    label: "Port Operations",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1769144256207-bc4bb75b29db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHNoaXBwaW5nJTIwcG9ydCUyMGNvbnRhaW5lciUyMGFlcmlhbHxlbnwwfHx8fDE3NzgwMzkxMDJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Cargo ship loaded with colourful containers at a busy port",
    label: "At Sea",
    span: "md:col-span-4",
  },
  {
    src: "https://images.unsplash.com/photo-1642418934307-cc2c5bf83e65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMGNvbnRhaW5lciUyMGFic3RyYWN0fGVufDB8fHx8MTc3ODAzOTEyOHww&ixlib=rb-4.1.0&q=85",
    alt: "Close up of a shipping train car",
    label: "Rail Freight",
    span: "md:col-span-4",
  },
  {
    src: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1400&q=85",
    alt: "Modern concrete architecture — turnkey project delivery",
    label: "Turnkey Projects",
    span: "md:col-span-6",
  },
  {
    src: "https://images.unsplash.com/photo-1766678340672-51e6be3a64d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMGNvbnRhaW5lciUyMGFic3RyYWN0fGVufDB8fHx8MTc3ODAzOTEyOHww&ixlib=rb-4.1.0&q=85",
    alt: "Cargo ship at sea with distant city lights at night",
    label: "Night Routes",
    span: "md:col-span-6",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-ink-50 py-14 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 md:mb-16">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
              03 — Field notes
            </p>
            <h2 className="font-heading font-black text-ink-900 tracking-[-0.03em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl max-w-3xl">
              Trade moves. We document it.
            </h2>
          </div>
          <a
            href="#contact"
            data-testid="gallery-cta"
            className="font-mono text-[12px] uppercase tracking-[0.22em] text-ink-900 border-b-2 border-signal pb-1 hover:text-signal transition-colors"
          >
            Request Media Kit →
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-[260px]">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden bg-ink ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.06]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/10 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-white">
                <span className="font-mono text-[11px] uppercase tracking-[0.22em]">
                  {img.label}
                </span>
                <Expand className="w-4 h-4 opacity-60 group-hover:opacity-100 transition-opacity" strokeWidth={1.6} />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
